<!--Mobile Header-->
<fgb-page-header [pageTitle]="'rewards.page.title'" [backButtonLink]="'/'"></fgb-page-header>
<!--Sub Nav-->
<div class="container">
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
</div>

<div class="container mt-3">
  <fgbcl-lottos-list [isList]="true" [defaultSort]="0"></fgbcl-lottos-list>
</div>
